import apiPaths from '../../api-paths';

export default {
  get(staffOriginal = null) {
    const route = staffOriginal ? `${apiPaths.CRM}/mail-footers/${encodeURIComponent(staffOriginal)}` : `${apiPaths.CRM}/mail-footers`;
    return axios.get(route);
  },
  save(data) {
    return axios.post(`${apiPaths.CRM}/mail-footers`, data);
  },
  getForMail(fromBaseParent = false) {
    if (fromBaseParent) {
      return axios.get(`${apiPaths.CRM}/mail-footers/for-mail?sendFromBaseParent=true`);
    }
    return axios.get(`${apiPaths.CRM}/mail-footers/for-mail`);
  },
  delete(id) {
    return axios.delete(`${ apiPaths.CRM }/mail-footers/${ id }`);
  }
}